<template>
    <b-card no-body>
        <b-card-header
            header-tag="header"
            class="p-3 cursor-pointer"
            role="tab"
            @click="toggleAccordion"
            :aria-expanded="isOpen.toString()"
            :aria-controls="id"
        >
            <div class="font-16  d-flex justify-content-between">
                {{ title }}

                <span class="font-18">
                    <i v-if="!isOpen" class="fal fa-chevron-down"></i>

                    <i v-else class="fal fa-chevron-down" style="transform: rotate(180deg);"></i>
                </span>
            </div>
        </b-card-header>

        <b-collapse
            :id="id"
            v-model="isOpen"
            role="tabpanel"
        >
            <b-card-body>
                <slot></slot> 
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
export default {
    name: "AccordionSetting",
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        visible: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen
        }
    },
    created() {
        if (this.visible) {
            this.isOpen = true
        }
    },
}
</script>

<style scoped>
.card {
    border: 2px solid #dedede;
    box-shadow: unset;
    transition: unset;
}

.card-header {
    border: unset;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/AccordionSetting.vue